module.exports = __webpack_public_path__ + "static/media/2.c03b9056.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/2.png
// module id = 1198
// module chunks = 0